import { queryOptions } from '@tanstack/react-query';

import {
  type HandledCloudResource,
  isResourceType,
} from '@/lib/types/resourceDefs';

import { fetchBackend } from './apiClient';
import type { CloudResource } from './resource';

type ImpactResource = {
  hashedID: string;
  managed: boolean;
};

export type CoverageResource = CloudResource & {
  impacts: ImpactResource[];
  impactedBy: ImpactResource[];
  managed: boolean;
};

export const coverageQueries = {
  all: () => ['coverage'],
  byProject: (projectId: string) => [...coverageQueries.all(), projectId],
  list: (projectId: string) =>
    queryOptions({
      queryKey: [...coverageQueries.byProject(projectId), 'list'],
      queryFn: async () => {
        return await listResources(projectId);
      },
    }),
} as const;

export const listResources = async (
  projectId: string,
): Promise<HandledCloudResource[]> => {
  const getResponse = await fetchBackend(`/coverage/${projectId}`, {
    method: 'GET',
  });

  if (!getResponse.ok) {
    throw new Error(`Error: ${getResponse.statusText}`);
  }

  const data = (await getResponse.json()) as {
    resources: CoverageResource[];
  };

  return data.resources.filter(isResourceType);
};
